<template>
  <popup-headline
    :class="additionalClassname"
    :title="translations.title"
    :is-loading="isLoading"
    :is-close-state="isCloseState"
    @toggle-popup="togglePopup"
  />
  <div
    v-show="translations.content && translations.content !== '' && state.isPopupOpened"
    class="u-mt--s"
  >
    <div
      class="c-hands-free-content u-font-size-large"
      v-html="translations.content"
    />
    <button
      v-if="translations.buttonText"
      class="c-button u-font-size-large u-mt--s"
      @click="buttonAction"
    >
      {{ translations.buttonText }}
    </button>
  </div>
</template>

<script>

import { state } from '@/composition/voiceState'
import PopupHeadline from '@/components/recipe/handFreeCookingStages/PopupHeadline.vue'

export default {
  components: {
    PopupHeadline
  },
  props: {
    translations: {
      type: Object,
      required: true
    },
    additionalClassname: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isCloseState: {
      type: Boolean,
      default: false
    }
  },
  emits: ['togglePopup', 'buttonAction'],
  setup(_, { emit }) {
    const togglePopup = () => {
      emit('togglePopup')
    }
    const buttonAction = () => {
      emit('buttonAction')
    }

    return {
      togglePopup,
      buttonAction,
      state
    }
  }
}
</script>
